<footer class="footer">
  <div class="container">
    <div class="footer-grid">
      <!-- About Us -->
      <div class="footer-column">
        <h3>About us</h3>
        <ul>
          <li *ngFor="let link of footerLinks.aboutUs">
            <a [routerLink]="link.link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Information -->
      <div class="footer-column">
        <h3>Informations</h3>
        <ul>
          <li *ngFor="let link of footerLinks.information">
            <a [routerLink]="link.link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Products -->
      <div class="footer-column">
        <h3>Products</h3>
        <ul>
          <li *ngFor="let link of footerLinks.products">
            <a [routerLink]="link.link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="footer-column">
        <h3>Contact us</h3>
        <ul>
          <li *ngFor="let link of footerLinks.contact">
            <a [href]="link.link" [target]="link.link.startsWith('http') ? '_blank' : '_self'">
              {{ link.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; {{ currentYear }} GLORIA. All rights reserved.</p>
    </div>
  </div>
</footer>
